export default __webpack_public_path__ + "static/media/p8.04180bac.jpg";